module.exports = __webpack_public_path__ + "static/media/cheveuxnappy-featuresplit-2.f97b033e.jpg";